export default __webpack_public_path__ + "static/media/zoho.41a506e7.svg";